import segmentDocument from './SegmentDocument/SegmentDocument'

export default [
  segmentDocument
]



// WEBPACK FOOTER //
// ./src/documents/index.js